import { isServer as e } from "@qwik.dev/core/build";
var t = (e) => {
	let t;
	if (typeof MessageChannel < "u") {
		let n = new MessageChannel(), r = !0;
		n.port1.onmessage = () => e(), t = () => {
			r && n.port2.postMessage(null);
		}, t.$destroy$ = () => {
			r && (r = !1, n.port1.onmessage = null, n.port1.close(), n.port2.close());
		};
	} else t = () => setTimeout(e);
	return t;
};
globalThis.qDev, globalThis.qInspector, globalThis.qDynamicPlatform, globalThis.qRuntimeQrl;
var n = "2.0.0-beta.45-dev+0da49c4", r = globalThis.__qwik__ ||= {};
e ? r.singletons ||= Object.create(null) : r[n] ||= Object.create(null);
var i = function(e) {
	return e.PAUSED = "paused", e.RESUMED = "resumed", e.HTML = "html", e.TEXT = "text", e;
}({});
"" + i.HTML + i.TEXT;
var a = !e && typeof document < "u", o = a ? document : void 0, s = {
	$DEBUG$: !1,
	$maxIdlePreloads$: 25
}, c = a && o.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload", l = /\.[mc]?js$/, u = new Map(), d, f, p = 0, m = [], h = t(S), g = t(T), _ = !1, v = !1, y = !1, b = [], x = () => {
	f &&= (m.sort((e, t) => e.$inverseProbability$ - t.$inverseProbability$), !1);
};
function S() {
	if (_ = !1, !m.length) return;
	x();
	let e = performance.now() + 10, t = !1;
	for (; m.length;) {
		let n = m[0];
		if (1 - n.$inverseProbability$ >= .99 || p < s.$maxIdlePreloads$) {
			if (m.shift(), E(n), performance.now() >= e) {
				t = !0;
				break;
			}
		} else break;
	}
	t && m.length && !_ && (_ = !0, h());
}
var C = (e, t, n) => {
	b.unshift({
		$bundle$: e,
		$inverseProbability$: t,
		$seen$: n
	});
}, w = () => {
	let e = b[b.length - 1], t = e.$bundle$;
	if (e.$deps$) {
		let n = e.$index$;
		if (n >= e.$deps$.length) return b.pop(), !1;
		let r = e.$deps$[n];
		e.$index$ = n + 1;
		let i = P(r.$name$);
		if (i.$inverseProbability$ === 0) return !0;
		let a = 1 - t.$inverseProbability$, o;
		if (a === 1 || a >= .99) o = Math.min(.01, 1 - r.$importProbability$);
		else {
			let e = (1 - r.$importProbability$ * a) / r.$factor$;
			o = Math.max(.02, i.$inverseProbability$ * e), r.$factor$ = e;
		}
		return b.push({
			$bundle$: i,
			$inverseProbability$: o,
			$seen$: e.$seen$
		}), !0;
	}
	if (e.$seen$?.has(t)) return b.pop(), !1;
	let n = t.$inverseProbability$;
	if (t.$inverseProbability$ = e.$inverseProbability$, n - t.$inverseProbability$ < .01) return b.pop(), !1;
	if (A != null && t.$state$ < 2 && (t.$state$ === 0 && (t.$state$ = 1, m.push(t)), f = !0), t.$deps$?.length) {
		let n = e.$seen$ || new Set();
		return n.add(t), e.$seen$ = n, e.$deps$ = t.$deps$, e.$index$ = 0, !1;
	}
	return b.pop(), !1;
};
function T() {
	if (y || !b.length) return;
	v = !1, y = !0;
	let e = a ? performance.now() + 10 : 0, t = !1;
	for (; b.length;) {
		t = !0;
		let n = w();
		if (a && n && performance.now() >= e) {
			v || (v = !0, g());
			break;
		}
	}
	y = !1, t && a && h();
}
var E = (e) => {
	if (e.$state$ >= 2) return;
	p++;
	let t = performance.now();
	e.$waitedMs$ = t - e.$createdTs$, e.$state$ = 2;
	let n = o.createElement("link");
	n.href = new URL(`${A}${e.$name$}`, o.baseURI).toString(), n.rel = c, n.as = "script", n.onload = n.onerror = () => {
		p--, e.$loadedMs$ = performance.now() - t, e.$state$ = 4, n.remove(), h();
	}, o.head.appendChild(n);
}, D = (e, t, n) => {
	C(e, t, n), a ? g() : T();
}, O = (e, t) => {
	let n = P(e);
	n && C(n, t);
}, k = (e, t) => {
	if (!e?.length) return;
	let n = t ? 1 - t : .4;
	if (Array.isArray(e)) for (let t = e.length - 1; t >= 0; t--) {
		let r = e[t];
		O(r, n);
	}
	else O(e, n);
	a ? g() : T();
};
a && document.addEventListener("qsymbol", (e) => {
	let { symbol: t, href: n } = e.detail;
	n && k(t.slice(t.lastIndexOf("_") + 1), 1);
});
var A, j, M = (e, t) => ({
	$name$: e,
	$state$: l.test(e) ? 0 : 3,
	$deps$: d ? t?.map((e) => ({
		...e,
		$factor$: 1
	})) : t,
	$inverseProbability$: 1,
	$createdTs$: performance.now(),
	$waitedMs$: 0,
	$loadedMs$: 0
}), N = (e) => {
	let t = new Map(), n = 0;
	for (; n < e.length;) {
		let r = e[n++], i = [], a, o = 1;
		for (; a = e[n], typeof a == "number";) a < 0 ? o = -a / 10 : i.push({
			$name$: e[a],
			$importProbability$: o,
			$factor$: 1
		}), n++;
		t.set(r, i);
	}
	return t;
}, P = (e) => {
	let t = u.get(e);
	if (!t) {
		let n;
		if (j) {
			if (n = j.get(e), !n) return;
			n.length || (n = void 0);
		}
		t = M(e, n), u.set(e, t);
	}
	return t;
}, F = (e, n, r) => {
	r && "P" in r && (s.$maxIdlePreloads$ = r.P), !(!a || e == null) && (A = e, n && n.then((e) => e.text()).then((e) => {
		j = N(JSON.parse(e));
		let n = [];
		for (let [e, t] of j.entries()) {
			let r = P(e);
			r.$deps$ = t, r.$inverseProbability$ < 1 && (n.push([r, r.$inverseProbability$]), r.$inverseProbability$ = 1);
		}
		if (!n.length) {
			h();
			return;
		}
		let r = 0, i = t(() => {
			let e = performance.now() + 10;
			for (; r < n.length;) {
				let [t, a] = n[r];
				if (r++, D(t, a), r < n.length && performance.now() >= e) {
					i();
					return;
				}
			}
			h();
		});
		i();
	}).catch(console.warn));
};
export { N as g, F as l, k as p };
